//import React from 'react';
import { useChat } from './useChat';
import { useAnalytics } from './useAnalytics';
import useTranslations from '@/apps/providers/useTranslations';

/**
 * ChatBubble - Floating action button that opens the chat
 * Displays in bottom-right corner with unread count badge
 * Tracks analytics when chat is opened
 */
function ChatBubble() {
  const { isOpen, toggleChat, unreadCount } = useChat();
  const analytics = useAnalytics();
  const { tr } = useTranslations();

  const handleClick = () => {
    analytics.trackChatOpened();
    toggleChat();
  };

  if (isOpen) return null;

  return (
    <button
      className="chat-bubble"
      onClick={handleClick}
      aria-label={tr('chat.bubble.open')}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>

      {unreadCount > 0 && (
        <span className="chat-badge">{unreadCount}</span>
      )}
    </button>
  );
}

export default ChatBubble;
